<template>
  <div class="block-header">
    <div>{{ title }}</div>
    <div v-if="showEdit" class="icon-wrap" @click="handleEdit"><svg-icon width="18" height="18" name="edit-block"/></div>
  </div>
</template>

<script>
import { UserModule } from '@/store/modules/user';
export default {
  name: 'blockHeader',
  props: {
    title: String,
    name: String,
    showEdit: {
      type: [Boolean, Number, String],
      default: true
    },
  },
  methods: {
    handleEdit() {
      const stuid = this.$route.params.id + '';
      const agentId = Number(UserModule.fkAgentId);
      this.$router.push({ name: 'studentApplicationForm', params: { stuid }, query: { agid: agentId, activeNames: this.name }});
    }
  }
}
</script>

<style lang='scss'>
.block-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  font-weight: bold;
  height: 36px;
  padding: 0 0.6em;
  background-color: #eee;
  .icon-wrap {
    padding-left: 2em;
    cursor: pointer;
    &:hover {
      .svg-fill {
        fill: $mainColor;
      }
    }
  }
}
</style>